import Vue from "vue";

/* eslint-disable */
export const EventBus = new Vue();